module.exports = __webpack_public_path__ + "static/media/de.5fc42695.svg";